var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSquareWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.567 1.09a1.835 1.835 0 00-1.134 0 1.86 1.86 0 00-.63.372c-.16.134-.335.31-.525.5L1.963 8.279c-.191.19-.367.366-.501.524a1.86 1.86 0 00-.372.631c-.12.369-.12.765 0 1.134.084.258.227.46.372.63.134.16.31.335.5.525l6.316 6.315c.19.191.366.367.524.501.171.145.373.288.631.372.369.12.765.12 1.134 0 .258-.084.46-.227.63-.372.16-.134.335-.31.526-.5l6.314-6.316c.191-.19.367-.366.501-.524.145-.171.288-.373.372-.631.12-.369.12-.765 0-1.134a1.859 1.859 0 00-.372-.63c-.134-.16-.31-.335-.5-.525l-6.316-6.315a9.471 9.471 0 00-.524-.501 1.86 1.86 0 00-.631-.372zm.183 4.66a.75.75 0 00-1.5 0v3.5a.75.75 0 001.5 0v-3.5zm0 7a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5z",
    fill: "#fff"
  })));
}
export default SvgAlertSquareWhite;